/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb


/**
 * Refers to app/javascript/stylesheets/application.scss (or application.css)
 * Note that we don't need to preface this path with "app/javascript" due to the `source_path` config set in config/webpacker.yml. Magical!
 * The file extension can be left off due to the `extensions` config in config/webpacker.yml.
 */
// require("@rails/ujs").start()
import Rails from "@rails/ujs"
import Turbolinks from "turbolinks"
import * as ActiveStorage from "@rails/activestorage"
import $ from "modules/jquery_global"
import "jquery-ui/ui/version"
import "jquery-ui/ui/data"
import "jquery-ui/ui/plugin"
import "jquery-ui/ui/scroll-parent"
import "jquery-ui/ui/widget"
import "jquery-ui/ui/widgets/mouse"
import "jquery-ui/ui/widgets/sortable"
import "jquery-ui/ui/disable-selection"
import "jquery-ui/ui/widgets/draggable"
import "jquery-ui/ui/widgets/droppable"
import "packs/keyboard_navigation"
import "modules/index"
import "views/index"
import "rails_sortable_override"
import "gradebook_scrolling_handler"
import "UnityProgress"
import "dropdown_menu_helper"
import "live_search_display"
import "truncation"
import "bulk_edit"
import "assignment_flow_helper"
import "launch_in_same_tab"
import "edit_activity_settings_helper"
import "searchable_dropdown"
import "packs/update_last_reminded"
import "packs/manage_sync_options"
import "packs/overview"
import "packs/assignments_index"
import "packs/assignments_auto_animate"
import "coffee"
window.Rails = window.Rails || Rails;
if (!window._rails_loaded) {
    window.Rails.start()
}
Turbolinks.start()
ActiveStorage.start()

import * as bootstrap from "bootstrap"
window.bootstrap = bootstrap

import "flatpickr";
import "accessible_calendar"
import "select2";
// import "@ttskch/select2-bootstrap4-theme";
import "../modules/bootstrap_modal_lifecycle";
import { focusFirstInteractive } from "../modules/modal_focus";

document.addEventListener("turbolinks:load", function() {
    $(function () {
        $('[data-bs-toggle="tooltip"]').tooltip()
        $('[data-bs-toggle="popover"]').popover()
    })

    $(".modal").on('hidden.bs.modal', function(){
        // TODO refocus on element that opened modal?
    });

    $(document).on('show.bs.modal', function(){
        addInputPrependListener();
    });

    // When modal opens, move focus to the first interactive element.
    $(document).on('shown.bs.modal', function(event){
        focusFirstInteractive(event.target);
    });

    addInputPrependListener();

    $("#vb-error-modal").modal("show");
})


import "coming_soon_actions"
import "../vendor/jQuery-Plugin-For-Multi-Selectable-Tree-Structure-Tree-Multiselect/dist/jquery.tree-multiselect.js.erb"
import "../vendor/jquery-ajaxQueue/jquery.ajaxQueue.min"

// Uncomment this in the future for using tinyMCE through webpack. For now 6/14/21 we're using sprockets
// import { tinyMce } from "../vendor/tinyMCE";
// document.addEventListener("turbolinks:load", function () {    tinyMce(); });

$(document).ready(function() {
    if ($('.alert-dismissible').length) {
        $(".hidden-for-alert").hide();
    }

    $('.alert-dismissible').on('closed.bs.alert', function () {
        $(".hidden-for-alert").show();
    })


});

 window.addInputPrependListener = function (){
    $('.input-group-prepend').on('click', function (e){
        let closestInput = $(this).closest("div.input-group").find("input")
        closestInput.focus();
    })
}
